import api from './api'
import app from './app'
import services from './services'

export default { app, api, services }
